import cn from 'classnames';

import { IConDefaultType } from '../types';

export interface IClearRoomIconProps extends IConDefaultType {}

function ClearRoomIcon({ color, className, size = 40, rotate, flip }: IClearRoomIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_4996_189430)">
          <path
            d="M23 43C34.0457 43 43 34.0457 43 23C43 11.9543 34.0457 3 23 3C11.9543 3 3 11.9543 3 23C3 34.0457 11.9543 43 23 43Z"
            fill="black"
          />
        </g>
        <path
          d="M23 43C34.0457 43 43 34.0457 43 23C43 11.9543 34.0457 3 23 3C11.9543 3 3 11.9543 3 23C3 34.0457 11.9543 43 23 43Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.8378 18C28.405 18 28.8649 18.4598 28.8649 19.027L28.8647 24H29.9189C30.4712 24 30.9189 24.4477 30.9189 25V26L30.9156 26.0681C31.8762 26.3197 32.6878 27.2406 32.6878 28.3657C32.6878 29.9455 32.9919 31.2916 33.5884 32.4049L33.7313 32.6577L33.89 32.9122C34.1648 33.3526 33.8945 33.9233 33.4133 33.9929L33.3143 34H22.3614C21.8132 34 21.4873 33.3686 21.7936 32.8998C22.5874 31.6846 22.9879 30.1791 22.9879 28.3657C22.9879 27.2403 23.7998 26.3193 24.7607 26.0679L24.7576 26.0348L24.7568 25C24.7568 24.4477 25.2045 24 25.7568 24H26.8107L26.8108 19.027C26.8108 18.4598 27.2706 18 27.8378 18ZM28.5 12C31.5376 12 34 14.4624 34 17.5V23H33.999L33.9933 23.1066C33.9355 23.604 33.5128 23.99 33 23.99C32.4511 23.99 32.0055 23.5477 32 23V17.5L31.9948 17.308C31.8951 15.4643 30.3686 14 28.5 14H17.5L17.308 14.0052C15.4643 14.1049 14 15.6314 14 17.5V28.5L14.0052 28.692C14.1049 30.5357 15.6314 32 17.5 32H20L20.1166 32.0067C20.614 32.0645 21 32.4872 21 33C21 33.5523 20.5523 34 20 34H17.5C14.4624 34 12 31.5376 12 28.5V17.5C12 14.4624 14.4624 12 17.5 12H28.5ZM30.2765 27.4H25.4001C24.9776 27.4 24.5194 27.835 24.5194 28.3323C24.5194 29.7195 24.3095 30.9696 23.8875 32.0772L23.7546 32.4052L23.7297 32.459L25.4467 32.458L25.4472 30.5228C25.4472 30.1086 25.792 29.7728 26.2174 29.7728C26.6074 29.7728 26.9297 30.055 26.9807 30.4211L26.9877 30.5228L26.9877 32.458H28.5277L28.5282 30.5228C28.5282 30.1086 28.8731 29.7728 29.2985 29.7728C29.6885 29.7728 30.0107 30.055 30.0618 30.4211L30.0688 30.5228L30.0687 32.458L31.9459 32.459L31.9212 32.4034C31.5001 31.4243 31.2538 30.3277 31.1805 29.1176L31.1624 28.7101L31.1571 28.3323C31.1571 27.835 30.6989 27.4 30.2765 27.4ZM19.108 19.005C19.1081 21.21 20.9465 23 23.2162 23C20.9465 23 19.1081 24.79 19.1081 27C19.1081 24.79 17.2697 23 15 23C17.201 23 18.9963 21.3168 19.1031 19.1997L19.108 19.005ZM22.1892 17C22.1892 18.105 23.1084 19 24.2432 19C23.1084 19 22.1892 19.895 22.1892 21C22.1892 19.895 21.27 19 20.1351 19C21.27 19 22.1892 18.105 22.1892 17Z"
          fill="#8A8A8A"
        />
        <defs>
          <filter
            id="filter0_d_4996_189430"
            x="0"
            y="0"
            width="46"
            height="46"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="1.5" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4996_189430" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4996_189430" result="shape" />
          </filter>
        </defs>
      </svg>
    </i>
  );
}

export default ClearRoomIcon;
